import { Button } from '@givebutter/primitives/button';
import { faMegaphone } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as ActivityItem from 'assets/js/pages/contacts/single/timeline/timeline-list/item/items/ActivityItem';
import { useSaveNote } from 'assets/js/pages/contacts/single/timeline/timeline-list/item/useSaveNote';
import * as EditableInput from 'components/editable-input';
import * as Form from 'components/form';
import { useForceRender } from 'customHooks/useForceRender';
import { CampaignJoinedActivity } from 'types/domain';

interface CampaignJoinedFormValues {
    note: string;
}

interface CampaignJoinedProps {
    item: CampaignJoinedActivity;
}

const CampaignJoined = ({ item }: CampaignJoinedProps) => {
    const note = item.data?.note ?? '';
    const { key, forceRender } = useForceRender();
    const { mutate: saveNote, isPending } = useSaveNote({
        onSuccess: () => {
            forceRender();
        },
    });
    const methods = Form.useGivebutterForm<CampaignJoinedFormValues>({
        defaultValues: {
            note,
        },
    });
    const { control, handleSubmit, path } = methods;

    const onSave = (values: CampaignJoinedFormValues) => {
        saveNote({ activityId: item.id, note: values.note });
    };

    const {
        resource: { campaign },
    } = item;

    return (
        <ActivityItem.Root key={key}>
            <ActivityItem.Trigger>
                <ActivityItem.Icon className="bg-blue-50">
                    <FontAwesomeIcon className="text-blue-500" icon={faMegaphone} />
                </ActivityItem.Icon>
                <p>
                    Joined{' '}
                    <a href={campaign.url} target="_blank" rel="noreferrer">
                        {campaign.title}
                    </a>{' '}
                    as a team member
                </p>
            </ActivityItem.Trigger>
            <ActivityItem.Content>
                <Form.GivebutterFormProvider {...methods}>
                    <form onSubmit={handleSubmit(onSave)}>
                        <EditableInput.Root>
                            <EditableInput.ReadOnly>
                                <ActivityItem.Note>{note}</ActivityItem.Note>
                            </EditableInput.ReadOnly>
                            <EditableInput.Content>
                                <Form.Container>
                                    <Form.Label name={path('note')}>Note</Form.Label>
                                    <Form.UseFormTextArea control={control} name={path('note')} />
                                </Form.Container>
                                <EditableInput.ActionsContainer>
                                    <EditableInput.Cancel />
                                    <Form.SubmitButton isSubmitting={isPending}>
                                        Save
                                    </Form.SubmitButton>
                                </EditableInput.ActionsContainer>
                            </EditableInput.Content>
                            <ActivityItem.Actions>
                                <EditableInput.ReadOnlyEditTrigger asChild>
                                    <Button variant="transparent">Edit</Button>
                                </EditableInput.ReadOnlyEditTrigger>
                            </ActivityItem.Actions>
                        </EditableInput.Root>
                    </form>
                </Form.GivebutterFormProvider>
            </ActivityItem.Content>
        </ActivityItem.Root>
    );
};

export default CampaignJoined;
